import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-theme-page',
  standalone: true,
  imports: [FormsModule, TabViewModule, ButtonModule],
  templateUrl: './theme.component.html',
  styleUrls: ['./theme.component.css']
})
export class ThemeComponent {
  sidebarColor = '#ff0000';
  selectedTab: 'sidebar' | 'global' = 'sidebar';

  selectTab(tab: 'sidebar' | 'global') {
    this.selectedTab = tab;
  }
}
